module.exports = __webpack_public_path__ + "static/media/a1.75df5ae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/AdvisorsPartnersTeamResources/a1.jpg
// module id = 245
// module chunks = 0